<template>
  <transition name="slide-fade">
    <div>
      <portal-target name="description" v-show="$breakpoint.smAndUp"></portal-target>
      <v-container fluid class="p-header" id="service_request">
        <div>
          <b-jumbotron>
            <template #header>PRIMACY HEALTH</template>

            <template #lead>
              <p class="text-center">To request a service, either login as a patient or register as a professional.</p>
            </template>

            <hr class="my-4 pt-5">

            <div class="layout justify-space-around">
              <v-btn large href="/service_request/create" @click.prevent.stop="goTo('/service_request/create', { replace: true })">Login</v-btn>

              <v-btn large href="/client/register" @click.stop.prevent="goTo('/client/register')" title="Register as a patient">Register as a Patient</v-btn>
            </div>

            <hr class="my-4">

<!--            <b-button variant="primary" href="#">Do Something</b-button>-->
<!--            <b-button variant="success" href="#">Do Something Else</b-button>-->
          </b-jumbotron>
        </div>
      </v-container>
      <v-container fluid class="">
        <v-layout wrap>
          <v-flex xs12 class="layout justify-center">
            <h3 class="text-center text-uppercase">Services</h3>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid class="container row" v-if="$breakpoint.mdAndUp">
        <div v-for="service in services" :key="service.title" class="col-md-3">
          <b-card
              :title="service.title"
              :img-src="service.image"
              :img-alt="service.title"
              img-top
              tag="services"
              class="mb-2"
          >
            <b-card-text>
              {{ service.text }}
            </b-card-text>
          </b-card>
        </div>
      </v-container>
      <v-container fluid v-else>
        <v-layout wrap justify-center>
          <template v-if="service_items.length == 0">
            <v-flex xs6 sm6 md6 v-for="i in 6" :key="i" class="pa-1">
              <v-skeleton-loader type="card"></v-skeleton-loader>
            </v-flex>
          </template>
          <v-flex xs6 sm6 md6 v-for="item in service_items" :key="item.id" class="">
            <service-items-component :service_item="item"></service-items-component>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid class="p-header2" v-if="!$user">
        <v-layout wrap justify-center align-center>
          <v-flex xs12 sm6 md6 order-md2 order-sm2 order-xs1 class="pa-5" title="Sign up to request for healthcare services">
            <v-card class="elevation-24" href="/client/register" @click.stop.prevent="goTo('/client/register')">
              <v-card-text class="text-center">
                <span>Sign-up as a patient</span>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 md6 order-md1 order-sm1 order-xs2 class="pa-5" title="Sign up as a physician, doctor, nurse, community healthcare provider, physiotherapist, e.t.c ">
            <v-card class="elevation-24" href="/professional/register" @click.stop.prevent="goTo('/professional/register')">
              <v-card-text class="text-center">
                <span>Sign-up as a healthcare professional</span>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid class="p-header2" v-else>
        <v-layout wrap justify-center align-center>
          <v-flex xs12 sm6 md6 order-md2 order-sm2 order-xs1 class="pa-5" title="Sign up to request for healthcare services">
            <v-card class="elevation-24" href="/user/client" @click.stop.prevent="goTo('/user/client')">
              <v-card-text class="text-center">
                <span>Go to patient profile</span>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 md6 order-md1 order-sm1 order-xs2 class="pa-5" title="Sign up as a physician, doctor, nurse, community healthcare provider, physiotherapist, e.t.c ">
            <v-card class="elevation-24" href="/user/professional" @click.stop.prevent="goTo('/user/professional')">
              <v-card-text class="text-center">
                <span>Go to professional profile</span>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <!-- <portal-target name="description" v-show="!$breakpoint.smAndUp"></portal-target> -->
    </div>
  </transition>
</template>

<script>
  import guestLayout from '@/Layouts/Guest'
  import CreateServiceRequest from '@/Components/ServiceRequest/create'
  // const CreateServiceRequest = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "service-requests" */ '@/Components/ServiceRequest/create')
  const ServiceItemsComponent = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/Pages/components/serviceItem')

  export default {
    name: 'Welcome',
    layout: guestLayout,
    components: {
      CreateServiceRequest,
      ServiceItemsComponent,
    },
    props: {
      packages: {
        default: () => []
      },
      insurance_providers: {
        default: () => [],
      },
      service_items: {
        default: () => [],
      }
    },
    metaInfo () {
      return {
        title: 'Welcome',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        data: '',
        loading: false,
        services: [
          {
            title: 'Home Medical Consultation',
            image: '/images/rameo-wB8eU7-LkzQ-unsplash.jpg',
            text: ''
          },
          {
            title: 'Laboratory Services',
            image: '/images/ousa-chea-gKUC4TMhOiY-unsplash.jpg',
            text: ''
          },
          {
            title: 'Pharmaceutical delivery (drugs)',
            image: '/images/myriam-zilles-KltoLK6Mk-g-unsplash.jpg',
            text: ''
          },
          {
            title: 'Home based nursing care and rehabilitation support',
            image: '/images/rameo-wB8eU7-LkzQ-unsplash.jpg',
            text: ''
          },
          {
            title: 'Nutrition Support Services',
            image: '/images/heather-ford-Ug7kk0kThLk-unsplash.jpg',
            text: ''
          },
          {
            title: 'TIKO',
            image: '/images/myriam-zilles-KltoLK6Mk-g-unsplash.jpg',
            text: ''
          },
          {
            title: 'Referrals and Linkages',
            image: '/images/jonnica-hill-V5nq6u-Ce_U-unsplash.jpg',
            text: ''
          },
          {
            title: 'Other Medical Services: (Family planning, Counselling, Wound care, etc.)',
            image: '/images/jonnica-hill-V5nq6u-Ce_U-unsplash.jpg',
            text: ''
          }
        ],
      }
    },
    computed: {
      pInfo () {
        return {
          backgroundColor: this.$vuetify.theme.isDark ? '#1e1e1e' : 'white',
          color: this.$vuetify.theme.isDark ? 'white' : 'black',
          fontSize: 'larger',
          margin: '2px',
          padding: '10px',
        }
      }
    },
    methods: {
      getData: _.debounce(function () {
				this.$inertia.visit('/', {
					only: ['service_items', 'packages', 'insurance_providers'],
					onBefore: () => {
						this.loading = true
					},
					onFinish: () => {
						this.loading = false
					},
          preserveState: true,
          preserveScroll: true,
				})
			}, 2000)
    },
    created () {
      // this.$nextTick(() => {
        // this.getData();
      // })
    },
    watch: {
      'packages': function (newvalue, oldvalue) {
				if (oldvalue.length > 1 && newvalue.length == 0) {
					this.getData()
				}
			},
      'insurance_providers': function (newvalue, oldvalue) {
				if (oldvalue.length > 1 && newvalue.length == 0) {
					this.getData()
				}
			},
    }
  }
</script>

<style scoped>

</style>
